<section class="w-100 float-left">
  <div class="slider_main">
    <div
      id="main_slider"
      class="carousel slide carousel-fade"
      data-ride="carousel"
    >
      <!-- <ol class="carousel-indicators">
                <li data-target="#main_slider" data-slide-to="1" class="active"></li>
            </ol> -->
      <div class="carousel-inner">
        <div class="carousel-item active first_slide_bg">
          <img
            class="d-md-block d-none"
            *ngIf="!mobileCheck()"
            src="assets/images/slide3.png"
            alt="third slide"
          />
          <div class="carousel-caption">
            <div class="container h-100">
              <div class="row h-100 align-items-center">
                <div
                  class="col-xl-5 col-lg-5 col-md-6 col-sm-12 col-12 float-left"
                >
                  <h5 class="slider_text_title">
                    <span class="slider_text_title_color1">MOBILITY</span>
                  </h5>
                  <span class="w-100 float-left slider_small_title"
                    >GO MOBILE GO CLOUD GO DIGITAL</span
                  >

                  <p class="slider_text">
                    We have developed 500+ mobile apps for startups, SMEs, and
                    established businesses worldwide. Our in-house mobile app
                    developers can work on any size project to deliver top-notch
                    mobility solutions.
                  </p>
                  <div class="w-100 float-left text-md-left text-sm-center">
                    <button class="main_btn" routerLink="/contact-us">
                      Click for Free Consultancy
                    </button>
                  </div>
                </div>
                <div
                  class="
                    col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12
                    d-md-block d-none
                  "
                ></div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="carousel-item slider_background">
                    <div class="container">
                        <div class="row">
                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 float-left slider-main-text">
                                <h5 class="slider_text_title d-flex justify-content-center align-items-center">
                                    <span class="animated bounceInDown">Mobility
                                        <span class="small_title">
                                            GO MOBILE GO CLOUD GO DIGITAL
                                        </span>
                                    </span>
                                </h5>
                                <p class="slider_text animated bounceInLeft">We have developed 500+ mobile apps
                                    for startups, SMEs, and established businesses worldwide. Our in-house mobile app
                                    developers can work on any size project to deliver top-notch mobility solutions.</p>
                                <div class="w-100 text-left"><button routerLink="/contact-us"
                                        class="main_btn animated bounceInUp">Know More</button> </div>
                            </div>
                            <div
                                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 slider_right_img float-right animated bounceInRight">
                                <img class="d-block w-100" src="assets/images/mobi.png" alt="First slide">
                            </div>
                        </div>
                    </div>
                </div> -->
      </div>
    </div>
  </div>
</section>
